import {
  GET_JEWELLERY_COIN_PRICE,
  SET_JEWELLERY_COIN_PRICE,
  POST_JEWELLERY_COIN_PRICE,
  GET_JCP_LIVE_QUOTE_TABLE,
  SET_JCP_LIVE_QUOTE_TABLE,
  CHANGE_JCP_STATUS,
  GET_LATEST_PUBLISHED_JCP,
  SET_LATEST_PUBLISHED_JCP,
  SEND_PRICE_CHANGE_NOTIFICATION_EMAIL,
  PUSH_TO_PRONTO,
} from '../constants/JewelleryCoinPrice';

export const getJewelleryCoinPrice = () => {
  return {
    type: GET_JEWELLERY_COIN_PRICE,
  };
};

export const setJewelleryCoinPrice = (jewelleryCoinPrice) => {
  return {
    type: SET_JEWELLERY_COIN_PRICE,
    jewelleryCoinPrice,
  };
};

export const postJewelleryCoinPrice = (jewelleryCoinPrice) => {
  return {
    type: POST_JEWELLERY_COIN_PRICE,
    jewelleryCoinPrice,
  };
};

export const getJcpLiveQuoteTable = () => {
  return {
    type: GET_JCP_LIVE_QUOTE_TABLE,
  };
};

export const setJcpLiveQuoteTable = (jcpLiveQuoteTable) => {
  return {
    type: SET_JCP_LIVE_QUOTE_TABLE,
    jcpLiveQuoteTable,
  };
};

export const changeJcpStatus = (data) => {
  return {
    type: CHANGE_JCP_STATUS,
    data: data,
  };
};

export const getLatestPublishedJcp = () => {
  return {
    type: GET_LATEST_PUBLISHED_JCP,
  };
};

export const setLatestPublishedJcp = (latestPublishedJcp) => {
  return {
    type: SET_LATEST_PUBLISHED_JCP,
    latestPublishedJcp,
  };
};

export const sendPriceChangeNotification = (payload) => {
  return {
    type: SEND_PRICE_CHANGE_NOTIFICATION_EMAIL,
    payload,
  };
};

export const pushToPronto = (payload) => {
  return {
    type: PUSH_TO_PRONTO,
    payload,
  };
};
